import { render, staticRenderFns } from "./GoodsReturnCreateForm.vue?vue&type=template&id=0d326ad4"
import script from "./GoodsReturnCreateForm.vue?vue&type=script&lang=js"
export * from "./GoodsReturnCreateForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports